export const enUi = {
  "ui.cheatCodeAccepted": "CHEAT CODE ACCEPTED",
  "ui.accessingMassifDeepSpaceNetwork":
    "ACCESSING MASSIF DEEP SPACE NETWORK...",
  "ui.640kMemoryOk": "640K MEMORY OK",
  "ui.loadingScrumExe": "LOADING SCRUM.EXE...",
  "ui.diskReadError": "DISK READ ERROR",
  "ui.abortRetryFail": "ABORT, RETRY, FAIL?",
  "ui.loadingSectorArt": "LOADING SECTOR ART...",
  "ui.retry": "RETRY",
  "ui.abort": "ABORT",
  "ui.soundOff": "Sound off",
  "ui.soundOn": "Sound on",
  "ui.exit": "Exit",
  "ui.fullscreen": "Fullscreen",
  "ui.exitFullscreen": "Exit fullscreen",
  "ui.hideControls": "Hide controls",
  "ui.showControls": "Show controls",
  "ui.language": "Language",
  "ui.continue": "Continue",
  "ui.newGame": "New game",
  "ui.more": "More...",
  "ui.textSpeed": "TEXT SPEED",
  "ui.mancomb": "Mancomb",
  "ui.useWith": "Use {item} with {target}",
};
